import { Chat as ChatIcon } from '@mui/icons-material'
import { Box, Drawer, Grid, SpeedDial } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { useMediaContext } from 'context/MediaContext'
import { Chat as ChatModel } from 'model/Chat'
import { Game as GameModel, GamePlayer } from 'model/Game'
import { Report } from 'model/Report'
import Chat from 'component/Chat/Chat'
import GameRegister from './GameRegister'
import { useLocation, useNavigate } from 'react-router-dom'
import * as gameRepository from 'repository/GameRepository'
import * as chatRepository from 'repository/ChatRepository'

import * as reportRepository from 'repository/ReportRepository'
import { useAuthContext } from 'context/AuthContext'

export default function Game() {
  const navigate = useNavigate()
  const { isPc } = useMediaContext()
  const { auth } = useAuthContext()
  const { search } = useLocation()
  
  const query = useMemo(() => new URLSearchParams(search), [search])
  const gameId = query.get('id')

  const [game, setGame] = useState<GameModel | null>(null)
  useEffect(() => {
    if (!gameId) {
      navigate('/')
      return
    }
    gameRepository.findFromCache(gameId)
      .then(() => {
        const unsub = gameRepository.watch(gameId, it => setGame(it))
        return () => unsub()
      })
      .catch(() => navigate('/'))
  }, [gameId])

  const [user, setUser] = useState<GamePlayer | null>(null)
  useEffect(() => {
    if (!auth) return
    if (!game) return

    if (game.host.uuid === auth.uid) setUser(game.host)
    else if (game.guest.uuid === auth.uid) setUser(game.guest)
    else navigate('/')
  }, [auth, game])

  const [report, setReport] = useState<Report | null>(null)
  useEffect(() => {
    if (!game) return
    if (!user) return
    const unsub = reportRepository.watch(game.id, it => setReport(it))
    return () => unsub()
  }, [game, user])

  const [chat, setChat] = useState<ChatModel | null>(null)
  useEffect(() => {
    if (!game) return
    if (!user) return
    const unsub = chatRepository.watch(game.id, it => setChat(it))
    return () => unsub()
  }, [game, user])

  const [displayDrawer, setDisplayDrawer] = useState(false)
  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
    setDisplayDrawer(open);
  };

  if (!user || !game || !chat || !report) {
    return (
      <></>
    )
  }
  else if (isPc) return (
    <Grid container sx={{height: '100%'}}>
      <Grid item md={7} sx={{height: '100%'}}>
        <GameRegister user={user} game={game} report={report} chat={chat} />
      </Grid>
      <Grid item md={5} sx={{height: '100%'}}>
        <Chat user={user} chat={chat} />
      </Grid>
    </Grid>
  )
  else return (
    <>
      <GameRegister user={user} game={game} report={report} chat={chat} />
      <SpeedDial
        ariaLabel='chat'
        sx={{ position: 'fixed', bottom: 32, right: 24 }}
        icon={<ChatIcon />}
        onClick={() => setDisplayDrawer(true)}
      />
      <Drawer anchor='right' open={displayDrawer} onClose={toggleDrawer(false)}>
        <Box sx={{ width: '80vw', height: '100%'}}>
          <Chat user={user} chat={chat}/>
        </Box>
      </Drawer>
    </>
  )
}
